import getPageName from "./getPageName";
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Pagination, Navigation]);
import resize from "./resize";
import initAddCardsButton from "./init-add-cards-button";

const feedback = () => {
  if (!getPageName().includes("otzyvy")) {
    return;
  }

  let swiper = null,
    valueDirection = getPageName().split("_")[1];

  const slider = document.querySelector(".feedback-video"),
    sliderWrap = document.querySelector(".feedback-slider__cards"),
    textWrap = document.querySelector(".feedback-text");

  createFeedbackContent(valueDirection);

  async function createFeedbackContent(value = "all") {
    let response, result;

    response = await fetch("/files/feedback.json");
    result = await response.json();

    /* Обнуляем блоки */
    sliderWrap.innerHTML = "";
    textWrap.innerHTML = "";

    let video = returnArrVideo(value, result);
    let text = returnArrText(value, result);

    if (video.length < 3) {
      slider.style.display = "none";
    } else {
      slider.style.display = "block";
      createVideo(video);
    }

    /*if (value == "all") {
      let filterImgArrtext = text.filter((it) => {
        return it.img.split("/").length > 4;
      });
      let filterAvatarArrtext = text.filter((it) => {
        return it.img.split("/").length < 5;
      });

      createText([...filterImgArrtext, ...filterAvatarArrtext]);
    } else {
      createText(text);
    }*/

    createText(text);
    initAddCardsButton("[data-add-button-feedback-container]", 20, 20);
  }

  /* Добавление видео отзывов */
  function createVideo(data) {
    /* Удаляет экземпляр Swiper */
    if (swiper) {
      swiper.destroy();
    }

    let content = '';

    data.forEach((item, i) => {
      content += `
              <div class="feedback-slider__card swiper-slide">
                <div class="feedback-slider__card-wrap video-${item.modal}" style="background: url('${item.poster}') no-repeat center; background-size: cover">
                  <video class="feedback-slider__card-videoFrame" loop="loop" muted="muted" preload="none" src=${item.src} playsinline=""></video>
                  <div class="feedback-slider__card-block">
                  <a data-fslightbox="review-${i}" href="${item.video}" class="feedback-slider__card-block__link"></a>
                    <p class="feedback-slider__card-block__text">Смотреть&nbsp;отзыв</p>
                  </div>
                  <div class="feedback-slider__card-bottom">
                    <p class="feedback-slider__card-bottom__name">${item.name}</p>
                    <p class="feedback-slider__card-bottom__profession">${item.profession}</p>
                  </div>
                </div>
              </div>
          `;
    });

    sliderWrap.innerHTML = content;

    setTimeout(() => {
      const slider = document.querySelector(".feedback-slider");

      function init() {
        if (!swiper) {
          swiper = new Swiper(slider, {
            speed: 200,
            loop: true,
            breakpoints: {
              1441: {
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: true,
              },
              991: {
                slidesPerView: 3,
                spaceBetween: 10,
                centeredSlides: true,
              },
              751: {
                centeredSlides: true,
                slidesPerView: 2,
                spaceBetween: 10,
              },
              375: {
                spaceBetween: 23,
                width: 300,
                centeredSlides: false,
              },
              0: {
                spaceBetween: 15,
                width: 280,
                centeredSlides: true,
              },
            },
            navigation: {
              nextEl: ".feedback-slider__next",
              prevEl: ".feedback-slider__prev",
              disabledClass: "last",
            },
            on: {
              init() {
                const totalSlides = this.slides.length;
                let i = 0;

                for (let item of this.slides) {
                  item.classList.contains("swiper-slide-duplicate") ? i++ : "";
                }

                document.querySelector(".feedback-pagination-total").innerHTML =
                  totalSlides - i;
              },
              slideChange() {
                const index_currentSlide = this.realIndex + 1;
                document.querySelector(
                  ".feedback-pagination-current"
                ).innerHTML = index_currentSlide;
              },
            },
          });
        }
      }

      function destroy() {
        if (swiper) {
          try {
            swiper.destroy();
            swiper = null;
          } catch (e) {
            console.log(e);
          }
        }
      }

      function resizeSwiper() {
        if (window.innerWidth <= 375) {
          destroy();
          init();
        } else {
          destroy();
          init();
        }
      }

      resizeSwiper();
      resize(resizeSwiper);

      refreshFsLightbox();
    }, 50);
  }

  /* Добавление текстовых отзывов */
  function createText(data) {
    let content = '';

    data.forEach((item) => {
      content += `
            <div class="feedback-text__item" data-add-button-item>
              <img class="d-desk" src="${item.img}" alt="Аватарка">
              <div class="feedback-text__item-wrap">
                <div class="feedback-text__item-head">
                  <img class="d-mob" src="${item.img}" alt="Аватарка">
                  <div class="feedback-text__item-head-wrap">
                    <h4>${item.name}</h4>
                    <p class="feedback-text__item-direction d-desk">Направление <a href="${item.directionLink}" target="_blank">${item.directionName}</a></p>
                    <p class="feedback-text__item-course d-desk">Курс ${item.course}</p>
                    <div class="feedback-text__item-rating">
                      <p>Рейтинг программы <span>${item.rating}</span>&nbsp;из&nbsp;<span>5</span></p>
                      <img src="/img/tgu/reviews/${item.star}.png" alt="Рейтинг">
                    </div>
                  </div>
                </div>
                <p class="feedback-text__item-direction d-mob">Направление <a href="${item.directionLink}" target="_blank">${item.directionName}</a></p>
                <p class="feedback-text__item-course d-mob">Курс ${item.course}</p>
                <p class="feedback-text__item-description">${item.text}</p>
              </div>
            </div>
          `;
    });

    textWrap.innerHTML = content;
  }

  /* Возвращает массив с видео отзывами */
  function returnArrVideo(value, result) {
    if (value === "all" && value !== "undefined") {
      let arr = [];

      result.forEach((el) => {
        let arrVideo = el.data.filter((item) => {
          return item.video;
        });

        if (arrVideo.length > 0) {
          arr.push(arrVideo);
        }
      });

      return [].concat.apply([], arr);
    } else {
      let selectTarget = result.filter((item) => {
        return item.direction == value;
      });

      let arrVideo;

      if (selectTarget.length > 0) {
        arrVideo = selectTarget[0].data.filter((item) => {
          return item.video;
        });
      } else {
        arrVideo = [];
      }

      return arrVideo;
    }
  }

  /* Возвращает массив с текстовыми отзывами */
  function returnArrText(value, result) {
    if (value === "all") {
      let arr = [];

      result.forEach((el) => {
        let arrText = el.data.filter((item) => {
          return item.text;
        });

        if (arrText.length > 0) {
          arr.push(arrText);
        }
      });

      return mixerArrays(...arr);
    } else {
      let selectTarget = result.filter((item) => {
        return item.direction == value;
      });

      let arrText;

      if (selectTarget.length > 0) {
        arrText = selectTarget[0].data.filter((item) => {
          return item.text;
        });
      } else {
        arrText = [];
      }

      return arrText;
    }
  }

  /* Из нескольких массивов создает новый массив, помещая элементы исходных по очереди */
  function mixerArrays(...arrays) {
    const mix = [];
    for (let i = 0; i < Math.max(...arrays.map((a) => a.length)); i++) {
      arrays.forEach((array) => {
        if (array[i] !== undefined) mix.push(array[i]);
      });
    }

    return mix;
  }
};

export default feedback;
